import React from 'react'
import BlogSection from '../../components/BlogComponents/BlogSection'
import MainBanner from '../../components/MainComponents/MainBanner';
import { bannerTestinomialImage, blogBanner, blogBanners, mainTitle } from '../../config';
import Footer from '../../components/MainComponents/Footer';
import AppointmentSection from '../../components/ServiceComponents/AppointmentSection';
import MeetOurExperts from '../../components/MainComponents/MeetOurExperts';
import { blogs } from '../../utils/BlogData';
import CallToActionSection from '../../components/MainComponents/CallToAction';
import ContactHeader from '../../components/MainComponents/ContactHeader';




const BlogPage = () => {
  return (
    <div className='bg-background'>
      <ContactHeader/>
         <MainBanner
        
          bannerTitle={mainTitle}
          banenrHeadline={"Inspiration and Insights for Your Well-being"}
          showButton={false}
          mainBannerImages = {[blogBanners.bannerOne,blogBanners.bannerTwo,blogBanners.bannerThree]}
          bannerDescription={
            "Explore expert tips, recovery stories, and the latest news in physiotherapy. Stay informed and empowered on your journey to better health"
          
          }
        />
        <BlogSection blogs={blogs}/>
        <AppointmentSection/>
        {/* <MeetOurExperts/> */}
        <CallToActionSection/>
        <Footer/>
    </div>
  )
}

export default BlogPage